import BorderColorIcon from '@mui/icons-material/BorderColor';

import {EMMAI_FORMS} from '../../../../../../../const';
import useEmmai from '../../../../../../../hooks/providers/useEmmai';
import ToolbarIconButton from '../ToolbarIconButton/ToolbarIconButton';

const EditPractitionerButton = () => {
  const {currentForm, setCurrentForm, setIsPractitionerUpdating} = useEmmai();

  if (currentForm !== EMMAI_FORMS.OFFICE_AND_PRACTITIONER_ACTIVITY) return null;

  const handleClick = () => {
    setCurrentForm(EMMAI_FORMS.ADD_OR_UPDATE_PRACTITIONER);
    setIsPractitionerUpdating(true);
  };

  return (
    <ToolbarIconButton onClick={handleClick} edge="end" aria-label="modifier praticien">
      <BorderColorIcon color="primary" sx={{fontSize: 12}} />
    </ToolbarIconButton>
  );
};

export default EditPractitionerButton;
